import React from 'react';

const StarBadge = ({
    text = 'NEW',
    textColor = 'white',
    size = 48,
    backgroundColor = 'var(--heading-color)',
}) => {

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={text}
        >
            <path
                d="M12 0C13.0381 0 13.94 0.931509 14.8975 1.1875C15.8882 1.45231 17.1336 1.10463 18.001 1.60645C18.8809 2.11555 19.1989 3.37283 19.9131 4.08691C20.6271 4.80095 21.8844 5.11921 22.3936 5.99902C22.8954 6.86639 22.5477 8.1118 22.8125 9.10254C23.0683 10.06 24 10.9618 24 12C24 13.0381 23.0685 13.94 22.8125 14.8975C22.5477 15.8882 22.8954 17.1336 22.3936 18.001C21.8844 18.8809 20.6272 19.1989 19.9131 19.9131C19.1991 20.6271 18.8808 21.8844 18.001 22.3936C17.1336 22.8954 15.8882 22.5477 14.8975 22.8125C13.94 23.0683 13.0382 24 12 24C10.9619 24 10.06 23.0685 9.10254 22.8125C8.11181 22.5477 6.86639 22.8954 5.99902 22.3936C5.11914 21.8844 4.80093 20.6272 4.08691 19.9131C3.37288 19.1991 2.11562 18.8808 1.60645 18.001C1.1046 17.1336 1.45231 15.8882 1.1875 14.8975C0.931704 13.94 0 13.0382 0 12C0 10.9619 0.931509 10.06 1.1875 9.10254C1.45231 8.11181 1.10463 6.86639 1.60645 5.99902C2.11555 5.11914 3.37283 4.80093 4.08691 4.08691C4.80095 3.37288 5.11921 2.11562 5.99902 1.60645C6.86639 1.1046 8.1118 1.45231 9.10254 1.1875C10.06 0.931705 10.9618 0 12 0Z"
                fill={backgroundColor}
            />
            <text
                x="12"
                y="12"
                fontSize={10}
                fontWeight={"bold"}
                fill={textColor}
                textAnchor="middle"
                dominantBaseline="central"
            >
                {text}
            </text>
        </svg>
    );
};

export default StarBadge;
